<template>
  <pt-post-manage class="pt-post-manage__withData"></pt-post-manage>
</template>

<script>
import PtPostManage from './index'
export default {
  name: 'pt-post-manage__withData',
  components: {
    'pt-post-manage': PtPostManage
  }
}
</script>
